import type { AbstractStepProps, AbstractStepState } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import type { FormApi } from "final-form";
import compact from "lodash/compact";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export abstract class AbstractKkvStep<
	StepFields = {},
	Props extends AbstractStepProps = AbstractStepProps,
	State extends AbstractStepState = AbstractStepState,
> extends AbstractStep<StepFields, Props, State> {
	protected renderContent(values: StepFields, form: FormApi<StepFields>): ReactNode {
		return (
			<>
				{this.renderHeader()}
				<Card.Body className="px-4 py-3 d-flex flex-column">
					{this.renderFields(form.getState().valid, values, form)}
				</Card.Body>
			</>
		);
	}

	private renderHeader(): ReactNode {
		return null;
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "calculator-form mx-auto"]).join(" ");
	}

	protected abstract renderFields(valid: boolean, values: StepFields, form: FormApi<StepFields>): ReactNode;
}
